/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { RateLimit } from './RateLimit';
import {
    RateLimitFromJSON,
    RateLimitFromJSONTyped,
    RateLimitToJSON,
    RateLimitToJSONTyped,
} from './RateLimit';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { LogicModuleType } from './LogicModuleType';
import {
    LogicModuleTypeFromJSON,
    LogicModuleTypeFromJSONTyped,
    LogicModuleTypeToJSON,
    LogicModuleTypeToJSONTyped,
} from './LogicModuleType';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { MilestoneSubtype } from './MilestoneSubtype';
import {
    MilestoneSubtypeFromJSON,
    MilestoneSubtypeFromJSONTyped,
    MilestoneSubtypeToJSON,
    MilestoneSubtypeToJSONTyped,
} from './MilestoneSubtype';
import type { GameMetadata } from './GameMetadata';
import {
    GameMetadataFromJSON,
    GameMetadataFromJSONTyped,
    GameMetadataToJSON,
    GameMetadataToJSONTyped,
} from './GameMetadata';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { AssetResponse } from './AssetResponse';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './AssetResponse';
import type { MilestoneCheckpoint } from './MilestoneCheckpoint';
import {
    MilestoneCheckpointFromJSON,
    MilestoneCheckpointFromJSONTyped,
    MilestoneCheckpointToJSON,
    MilestoneCheckpointToJSONTyped,
} from './MilestoneCheckpoint';
import type { DataSource } from './DataSource';
import {
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    DataSourceToJSONTyped,
} from './DataSource';
import type { EventValidatorResponse } from './EventValidatorResponse';
import {
    EventValidatorResponseFromJSON,
    EventValidatorResponseFromJSONTyped,
    EventValidatorResponseToJSON,
    EventValidatorResponseToJSONTyped,
} from './EventValidatorResponse';

/**
 * 
 * @export
 * @interface MilestoneWithGameMetadata
 */
export interface MilestoneWithGameMetadata {
    /**
     * 
     * @type {GameMetadata}
     * @memberof MilestoneWithGameMetadata
     */
    game?: GameMetadata;
    /**
     * Always present — prepareForResponse() sets it unconditionally. Declared required so the response type stays assignable wherever the base LogicModule's required `id` is expected.
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    id: string;
    /**
     * 
     * @type {LogicModuleType}
     * @memberof MilestoneWithGameMetadata
     */
    logicType: LogicModuleType;
    /**
     * 
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    targetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    sessionAmount?: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof MilestoneWithGameMetadata
     */
    sessionCadence?: QuestReset;
    /**
     * 
     * @type {EventValidatorResponse}
     * @memberof MilestoneWithGameMetadata
     */
    triggerEvent: EventValidatorResponse;
    /**
     * 
     * @type {EventValidatorResponse}
     * @memberof MilestoneWithGameMetadata
     */
    resetEvent?: EventValidatorResponse;
    /**
     * 
     * @type {EventValidatorResponse}
     * @memberof MilestoneWithGameMetadata
     */
    finishEvent?: EventValidatorResponse;
    /**
     * 
     * @type {Array<DataSource>}
     * @memberof MilestoneWithGameMetadata
     */
    sources: Array<DataSource>;
    /**
     * 
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    gameId?: string;
    /**
     * 
     * @type {RateLimit}
     * @memberof MilestoneWithGameMetadata
     */
    rateLimit?: RateLimit;
    /**
     * 
     * @type {Array<string>}
     * @memberof MilestoneWithGameMetadata
     */
    rewardConfigIds?: Array<string>;
    /**
     * Per-reward auto-claim settings. Key is rewardConfigId, value is true for auto-reward, false for manual claim.
     * @type {{ [key: string]: boolean; }}
     * @memberof MilestoneWithGameMetadata
     */
    rewardAutoSettings?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof MilestoneWithGameMetadata
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof MilestoneWithGameMetadata
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    description?: string;
    /**
     * Epoch ms this step unlocks. Absent means it is open from the start. A step whose date has not arrived is visible but locked, so the ladder shows what is coming.
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    opensAt?: number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    progressionOrder?: number;
    /**
     * How often auto-rewards are distributed (e.g., 1 = per event for leaderboards). Works with rewardAutoSettings.
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    rewardPer?: number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    displayDivider?: number;
    /**
     * 
     * @type {Array<MilestoneCheckpoint>}
     * @memberof MilestoneWithGameMetadata
     */
    checkpoints?: Array<MilestoneCheckpoint>;
    /**
     * 
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    url?: string;
    /**
     * 
     * @type {MilestoneSubtype}
     * @memberof MilestoneWithGameMetadata
     */
    subtype?: MilestoneSubtype;
    /**
     * Controls rendering order on frontend (lower = higher priority)
     * @type {number}
     * @memberof MilestoneWithGameMetadata
     */
    displayPriority?: number;
    /**
     * Asset ID for example photo (PHOTO subtype only)
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    photoExampleAssetId?: string;
    /**
     * 
     * @type {AssetResponse}
     * @memberof MilestoneWithGameMetadata
     */
    photoExampleAsset?: AssetResponse;
    /**
     * Instructions for photo capture (PHOTO subtype only)
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    photoInstructions?: string;
    /**
     * Instructions for code entry (CODE_ENTRY subtype only)
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    codeInstructions?: string;
    /**
     * Instructions for QR scan (QR_SCAN subtype only)
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    scanInstructions?: string;
    /**
     * Regex pattern for valid QR codes (QR_SCAN subtype only)
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    validQrPattern?: string;
    /**
     * IDs of EventPipelineFilter documents applied to this milestone's events. Layered on top of the game-wide GLOBAL filter; empty = GLOBAL-only.
     * @type {Array<string>}
     * @memberof MilestoneWithGameMetadata
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this milestone (PRODUCT_PLAN D2(b)). Each entry names one global filter this milestone opts out of, with a required reason and a required absolute expiry. Evaluated as set membership against the blocking-filter ids stamped on the fan-out message; expiry is enforced at read.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof MilestoneWithGameMetadata
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this milestone still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a milestone that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof MilestoneWithGameMetadata
     */
    failOpenOnMissingContext?: boolean;
    /**
     * react-icons key for the step's tile on the journey map (e.g. FaDownload, FaGamepad, FaBullseye). Authored in the Journey Editor's steps list.
     * @type {string}
     * @memberof MilestoneWithGameMetadata
     */
    icon?: string;
}



/**
 * Check if a given object implements the MilestoneWithGameMetadata interface.
 */
export function instanceOfMilestoneWithGameMetadata(value: object): value is MilestoneWithGameMetadata {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('logicType' in value) || value['logicType'] === undefined) return false;
    if (!('targetAmount' in value) || value['targetAmount'] === undefined) return false;
    if (!('triggerEvent' in value) || value['triggerEvent'] === undefined) return false;
    if (!('sources' in value) || value['sources'] === undefined) return false;
    return true;
}

export function MilestoneWithGameMetadataFromJSON(json: any): MilestoneWithGameMetadata {
    return MilestoneWithGameMetadataFromJSONTyped(json, false);
}

export function MilestoneWithGameMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneWithGameMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'game': json['game'] == null ? undefined : GameMetadataFromJSON(json['game']),
        'id': json['id'],
        'logicType': LogicModuleTypeFromJSON(json['logicType']),
        'targetAmount': json['targetAmount'],
        'sessionAmount': json['sessionAmount'] == null ? undefined : json['sessionAmount'],
        'sessionCadence': json['sessionCadence'] == null ? undefined : QuestResetFromJSON(json['sessionCadence']),
        'triggerEvent': EventValidatorResponseFromJSON(json['triggerEvent']),
        'resetEvent': json['resetEvent'] == null ? undefined : EventValidatorResponseFromJSON(json['resetEvent']),
        'finishEvent': json['finishEvent'] == null ? undefined : EventValidatorResponseFromJSON(json['finishEvent']),
        'sources': ((json['sources'] as Array<any>).map(DataSourceFromJSON)),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'rateLimit': json['rateLimit'] == null ? undefined : RateLimitFromJSON(json['rateLimit']),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : json['rewardAutoSettings'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'opensAt': json['opensAt'] == null ? undefined : json['opensAt'],
        'progressionOrder': json['progressionOrder'] == null ? undefined : json['progressionOrder'],
        'rewardPer': json['rewardPer'] == null ? undefined : json['rewardPer'],
        'displayDivider': json['displayDivider'] == null ? undefined : json['displayDivider'],
        'checkpoints': json['checkpoints'] == null ? undefined : ((json['checkpoints'] as Array<any>).map(MilestoneCheckpointFromJSON)),
        'url': json['url'] == null ? undefined : json['url'],
        'subtype': json['subtype'] == null ? undefined : MilestoneSubtypeFromJSON(json['subtype']),
        'displayPriority': json['displayPriority'] == null ? undefined : json['displayPriority'],
        'photoExampleAssetId': json['photoExampleAssetId'] == null ? undefined : json['photoExampleAssetId'],
        'photoExampleAsset': json['photoExampleAsset'] == null ? undefined : AssetResponseFromJSON(json['photoExampleAsset']),
        'photoInstructions': json['photoInstructions'] == null ? undefined : json['photoInstructions'],
        'codeInstructions': json['codeInstructions'] == null ? undefined : json['codeInstructions'],
        'scanInstructions': json['scanInstructions'] == null ? undefined : json['scanInstructions'],
        'validQrPattern': json['validQrPattern'] == null ? undefined : json['validQrPattern'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function MilestoneWithGameMetadataToJSON(json: any): MilestoneWithGameMetadata {
    return MilestoneWithGameMetadataToJSONTyped(json, false);
}

export function MilestoneWithGameMetadataToJSONTyped(value?: MilestoneWithGameMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': GameMetadataToJSON(value['game']),
        'id': value['id'],
        'logicType': LogicModuleTypeToJSON(value['logicType']),
        'targetAmount': value['targetAmount'],
        'sessionAmount': value['sessionAmount'],
        'sessionCadence': QuestResetToJSON(value['sessionCadence']),
        'triggerEvent': EventValidatorResponseToJSON(value['triggerEvent']),
        'resetEvent': EventValidatorResponseToJSON(value['resetEvent']),
        'finishEvent': EventValidatorResponseToJSON(value['finishEvent']),
        'sources': ((value['sources'] as Array<any>).map(DataSourceToJSON)),
        'gameId': value['gameId'],
        'rateLimit': RateLimitToJSON(value['rateLimit']),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardAutoSettings': value['rewardAutoSettings'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'name': value['name'],
        'description': value['description'],
        'opensAt': value['opensAt'],
        'progressionOrder': value['progressionOrder'],
        'rewardPer': value['rewardPer'],
        'displayDivider': value['displayDivider'],
        'checkpoints': value['checkpoints'] == null ? undefined : ((value['checkpoints'] as Array<any>).map(MilestoneCheckpointToJSON)),
        'url': value['url'],
        'subtype': MilestoneSubtypeToJSON(value['subtype']),
        'displayPriority': value['displayPriority'],
        'photoExampleAssetId': value['photoExampleAssetId'],
        'photoExampleAsset': AssetResponseToJSON(value['photoExampleAsset']),
        'photoInstructions': value['photoInstructions'],
        'codeInstructions': value['codeInstructions'],
        'scanInstructions': value['scanInstructions'],
        'validQrPattern': value['validQrPattern'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'icon': value['icon'],
    };
}

